export {
  MasterDetailPlugin,
  type MasterDetailPluginOptions,
  type DetailTableOptions
} from './master-detail-plugin/index';
